import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DropdownButton, Div, Icon, Flex } from 'ui';
import { injectIntl } from 'react-intl';
import { viewModes } from 'utils/app-configs';
import fullScreenInActive from '../../../assets/images/viewMode/fullscreenDark.png';
import fullScreenActive from '../../../assets/images/viewMode/fullscreenDarkActive.png';
import topInActive from '../../../assets/images/viewMode/topActive.png';
import bottomInActive from '../../../assets/images/viewMode/bottomActive.png';
import topBottomInActive from '../../../assets/images/viewMode/topBottomActive.png';

const MainMenuToggleViewMode = styled.div`
  position: absolute;
  right: 10px;
`;

const StyledDropdownButton = styled(DropdownButton)`
  div > button:first-child > span{
    display: flex;
  }

  .ant-dropdown-menu-item:nth-child(4){
    padding: 0;
    margin: 2px 0;
    background: white;
    height: 1px;
  }
`;

const StyledImg = styled.img`
  margin: 0 8px 3px -5px;
  width: 20px;
`;

const StyledDiv = styled(Div)`
  text-transform: uppercase;
  display: flex;
  flex-grow: 1;
`;

const StyledIcon = styled(Icon)`
  margin-left: 10px !important;
  color: white;
  display: block;
  margin: auto;
`;

const getViewIcon = (currentView) => {
  switch (currentView) {
    case viewModes.TOP:
      return topInActive;
    case viewModes.BOTTOM:
      return bottomInActive;
    default:
      return topBottomInActive;
  }
};

const PlanningBoardMenu = ({
  intl,
  setFullScreen,
  setViewMode,
  fullScreen,
  viewMode,
}) => {
  const fullScreenIcon = fullScreen ? fullScreenActive : fullScreenInActive;
  const fullScreenText = fullScreen ?
    intl.formatMessage({ id: 'planningBoard.EXIT_FULLSCREEN' }) :
    intl.formatMessage({ id: 'planningBoard.ENTER_FULLSCREEN' });

  const toggleViewMode = (mode) => {
    switch (mode) {
      case viewModes.TOP:
        setViewMode(viewModes.TOP);
        break;
      case viewModes.BOTTOM:
        setViewMode(viewModes.BOTTOM);
        break;
      case viewModes.FULLSCREEN:
        setFullScreen(!fullScreen);
        break;
      default:
        setViewMode(viewModes.TOPBOTTOM);
    }
  };

  const renderIcon = mode =>
    viewMode === mode && <StyledIcon className={'fa-solid fa-check'} size='l' />;

  const renderOptionButton = (src, text, mode = null) => <Flex>
    <StyledImg src={src} />
    <StyledDiv>{intl.formatMessage({ id: text })}</StyledDiv>
    {mode && renderIcon(mode)}
  </Flex>;

  return <MainMenuToggleViewMode>
    <StyledDropdownButton
      asSeperate={false}
      text={<img src={getViewIcon(viewMode)} />}
      subItems={
        [
          {
            text:
              renderOptionButton(topInActive, 'planningBoard.GANTT_ONLY', viewModes.TOP),
            onClick: () => toggleViewMode(viewModes.TOP),
          },
          {
            text:
              renderOptionButton(bottomInActive, 'planningBoard.WORKLIST_ONLY', viewModes.BOTTOM),
            onClick: () => toggleViewMode(viewModes.BOTTOM),
          },
          {
            text:
              renderOptionButton(topBottomInActive, 'planningBoard.BOTH', viewModes.TOPBOTTOM),
            onClick: () => toggleViewMode(viewModes.TOPBOTTOM),
          },
          {
            type: 'divider',
          },
          {
            text:
              renderOptionButton(fullScreenIcon, fullScreenText),
            onClick: () =>
              toggleViewMode(viewModes.FULLSCREEN),
          },
        ]}
    />
  </MainMenuToggleViewMode>;
};

PlanningBoardMenu.propTypes = {
  intl: PropTypes.object,
  setViewMode: PropTypes.func.isRequired,
  setFullScreen: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  viewMode: PropTypes.string.isRequired,
};

export default injectIntl(PlanningBoardMenu);
